export const SET_LEDGER_ENV = "SET_LEDGER_ENV";

export const setLedgerEnv = (environment) => ({
  type: SET_LEDGER_ENV,
  payload: environment,
});
